export class BillingAccountProperties {
    accountid: number;
    accountidstring: string;
    accounttype: string;
    cardtype: string;
    cardsuffix: string;
    description: string;
    removable: boolean;
    expiration: string;
    balance: {};
    isdefault: boolean;
}
